// Checklist - PAVADINIMAS (puslapis)

page.checklist.pavadinimas = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    check: function(){ // Šitą funkciją vykdo kai tikrina užkrauto puslapio DOM, ieško elementų
        this.reset();
        if(page.v.firstLoad) this.first(); // Pirmą kart užkrovus tinklapį galima susikurti kažkokius pastovius kintamuosius ir t.t.

        if($('.section-about-1').length > 0 || $('.section-destinations').length > 0){ // jei randi reikiamą elementą - modulis įjungiamas.
            log.page("CHECK: ABOUT page detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){ // Ši funkcija vykdoma iškart po DOM apdorojimo, galima kabint eventus ir t.t.


        page.main.fr.socialLinks.init();
        page.main.fr.floatLabels.init();
        page.main.fr.altMenu.default();

        let hash = window.location.hash;


        if(hash){
            $('html, body').animate({
                scrollTop: $(hash.replace('%C5%B3', 'ų')).offset().top - 50
            }, 800);
        }
        if($('.apie-prl-cnt').length > 0) {

            $('.apie-prl-cnt').find('a').click(function (e) {
                hash = $(this).attr('href').split('#');
                if (hash.length > 1) {
                    $('html, body').animate({
                        scrollTop: $('#' + hash[1].replace('%C5%B3', 'ų')).offset().top - 50
                    }, 800);
                }
            })

        }


        this.resize();
    },
    first: function(){ // Ši funkcija vykdoma pirmą kartą užkrovus tinklapį


    },
    unload: function(){ // Ši funkcija skirta išvalyti eventams prieš nukraunant puslapį per ajax.
        page.main.fr.socialLinks.destroy();
        page.main.fr.floatLabels.destroy();
    },
    calc: function(){ // Ši funkcija vykdoma kiekvieno kadro metu (animacijoms ir t.t.)

    },
    resize: function(){ // onResize funkcija (pati administruojasi, nereikia atrišinėti)

    },
    scroll: function(){ // onScroll funkcija (pati administruojasi)

    },
    v: {
        // Jei reikalingi vidiniai kintamieji programos darbui, kurie turi išlikti tarp funkcijų vydymo
    },
    f: {
        // Jei reikalingos papildomos vidinės funkcijos modulio veikimui
    }
}